export const contributionExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Community',
		render: c => c?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: c => c?.sansthaId?.name || '',
	},
	{
		label: 'User Name',
		render: c => (c?.userId ? `${c.userId.firstName || ''} ${c.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: c => c?.userId?.mobile || '',
	},
	{
		label: 'Contribution Type',
		render: c => c?.contributionType || '',
	},
	{
		label: 'Payment Type',
		render: c => (c?.isOffline ? 'Offline' : 'Online'),
	},
	{
		label: 'Amount',
		render: c => c?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: c => c?.paymentMode || '',
	},
	{
		label: 'Payment Ref No',
		render: c => c?.paymentRef || '',
	},
	{
		label: 'Payment Date',
		render: c => (c?.updatedAt ? new Date(c.updatedAt).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'Status',
		render: c => c?.status || '',
	},
]
